<template>
    <div class="page">
        <div class="treatment-container">
            <div class="treatment-wrapper">
                <div class="description">
                    <h2>Akupunktio</h2>
                    <p>
                        Akupunktio on käytetyin kiinalaisen lääketieteen hoitomuoto länsimaissa.
                        Akupunktiossa käytetään ohuita, steriilejä kertakäyttöisiä neuloja.
                        Neulat laitetaan akupunktio- tai ashipisteisiin halutun vaikutuksen mukaan.
                        Hoitovaikutukset tulevat kumulatiivisesti eli parhaat tulokset saadaan hoitosarjan avulla.
                        Tuloksiin vaikuttavat myös asiakkaan mahdollisuudet tehdä muutoksia mm. ruokavalioon tai elämäntapoihin.
                    </p>
                </div>
                <div class="image">
                    <img src="@/assets/acupuncture.jpg" alt="Acupuncture treatment image">
                </div>
            </div>
            <div class="treatment-wrapper">
                <div class="image">
                    <img src="@/assets/earacu.jpg" alt="Ear acupuncture treatment image">
                </div>
                <div class="description">
                    <h2>Korva-akupunktio</h2>
                    <p>
                        Korva-akupunktio perustuu elimistön häiriötilojen tasapainottamiseen korvan akupunktiopisteiden kautta.
                        Korvassa olevien akupunktiopisteiden ajatellaan stimuloivan aivoverkostoa sekä sympaattista ja parasympaattista hermostoa, johon perustuu sen kipua ja sairauksia lievittävä/ parantava vaikutus.
                        WHO:n mukaan korva-akupunktiolla voidaan todistettavasti hoitaa 245 sairautta.
                        <br />
                        Diagnoosin jälkeen tehdään pistevalinnat, korvasta etsitään metallisella puikolla aktiivisia pisteitä.
                        Pisteen ollessa aktiivinen se reagoi yleensä kivulla puikolla painamiseen.
                        Esimerkiksi erilaisissa kivuissa voidaan käydä selän, käden tai jalan alue läpi puikolla ja valita sieltä pisteitä, jotka reagoivat.
                        Korvassa voidaan käyttää neuloja tai tarralla kiinnitettäviä kuulia tai siemeniä.
                        On yleistä, että korva alkaa punoittaa tai tuntuu aralta hoidon aikana ja jälkeen.
                        Punoitus ja arkuus ovat väliaikaista. Hoidon kannalta tämä on hyvä merkki ja lupaa hyvää vastetta.
                        Oireet saattavat hävitä nopeastikin, mutta yleensä hoidon vasteen näkee vuorokauden kuluttua hoidosta.
                    </p>
                </div>
            </div>
            <div class="treatment-wrapper">
                <div class="description">
                    <h2>Motorinen akupunktio, ortopedinen akupunktio</h2>
                    <p>
                        Motorinen akupunktio on tekniikka, jossa käytetään lihasten motorisiapisteitä/ alueita (liikehermo ja sen haarat) akupunktiopisteiden sijaan.
                        Joissakin kehon osissa akupunktio- ja motorinenpiste ovat samassa kohtaa.
                        Tässä tekniikassa lähestytään akupunktiota lihasten toiminnallisuuden kannalta ja hyödynnetään triggerpiste heijasteita.
                        Neulalla etsitään lihaksen motorinenpiste, joka saa liikehermon aktivoitumaan ja neulaan johdetaan sähköä.
                        Sähkö saa liikehermon aktivoitumaan ja lihas supistuu.
                        Jos sähkö aktivoi liikehermon pienempää haaraa, saattaa lihas aktivoitua voin osittain.
                        Jo pelkkä neula motorisessa pisteessä auttaa, mutta sähkö nopeuttaa ja tehostaa vaikutusta.
                        Motorinen akupunktio ei satu, vaikka saattaa kuulostaa hurjalta.
                        Välillä sähkö saattaa aiheuttaa terän tunteen ja ei aktivoi lihasta.
                        Tämä johtuu siitä, että sähkö aktivoi tuntohermoa liikehermon sijasta.
                        Tämä menee yleensä ohi neulan liikuttamisella tai uuden neulan pistämisellä hieman toisesta kohdasta.
                    </p>
                    <p>
                        Motorinen akupunktio vapauttaa kireitä lihaksia ja auttaa lihasta aktivoitumaan paremmin.
                        Kireä lihas on lyhentyneessä tilassa, jolloin sen liikelaajuus on huonontunut.
                        Sähkö auttaa lihasta rentoutumaan ja saamaan liikelaajuutensa takaisin, jolloin myös voimantuotto parantuu.
                        Kireän lihaksen alueella saattaa olla huonompi hermotus. Motorista akupunktiota voidaan hyödyntää myös leikkauksen jälkeisiin lihaksen hermotus ongelmiin, sähkö auttaa lihasta aktivoitumaan paremmin.
                        Proprioseptio eli asento- ja liikeaisti parantuvat, kun lihas pääsee liikkumaan normaalisti.
                        Voi olla, että on tottunut esimerkiksi puremaan hampaitaan yhteen tai jännittämään hartioita, jolloin lihakset ovat jännittyneessä tilassa ja kehon proprioseptio on häiriintynyt ja ihminen ei edes välttämättä huomaa toimivansa näin.
                        Lihaksen rentoutuessa lihas-hermoyhteys pääsee toimimaan normaalisti. Veri kulkee paremmin, kipu ja tulehdus vähentyvät.
                    </p>
                </div>
                <div class="image">

                </div>
            </div>
            <div class="treatment-wrapper">
                <div class="image">
                    <img src="@/assets/fireneedle.jpg" alt="Acupuncture treatment image">
                </div>
                <div class="description">
                    <h2>Tulineula</h2>
                    <p>
                        Tulineulalla on pitkä historia Kiinassa.
                        Menetelmän nimi tulee siitä, että neulaa kuumennetaan tulella ja kuumennetulla neulalla käsitellään haluttua aluetta.
                        Tulineulalla on paljon erilaisia käyttökohteita, erityisen hyvä se on kroonisissa vaivoissa.
                        Tulineula edistää aineenvaihduntaa ja parantaa Veren kiertoa. Sillä on kaksi toimintatapaa, se yhdistää perinteisen akupunktioneulan vaikutuksen ja moxan.
                        Eli se liikuttaa ja lämittää samalla. Tuli neulan ajatellaan avaavan oven, jotta patogeeni pääsee ulos.
                        Perinteistä akupunktioneulaa käytettäessä reikä menee heti umpeen.
                        Tulineula on sen verran paksumpi ja polttaa ihoa, että reikä jää auki ja patogeeni pääsee ulos.
                        Samalla periaattella tulineula toimii myös erilaisissa tulehduksissa, se hajottaa kuumuutta ja vetää sen ulos.
                    </p>
                    <p>
                        Tulineulalla tehtävästä arpihoidosta olen saanut hyviä tuloksia kipuihin, kutinaan, kiristyksen tunteisiin ja kosmeettisiin haittoihin.
                        Tulineulalla voidaan hoitaa myös rasva- ja varsiluomia sekä syyliä. Usein ne kuivuvat ja tippuvat pois 3–5 hoitokerran jälkeen.
                    </p>
                    <p>
                        Tulineulalla voidaan käyttää myös seuraavien vaivojen hoidossa:
                        <ul class="inline-list">
                            <li>heikkoa ja väsynyttä alaselkää, heikkoja polvia, tiheää virtsaamista</li>
                            <li>kipua alavatsalla, hedelmättömyyttä</li>
                            <li>pyörrytys, huimaus, tinnitus</li>
                            <li>korkea verenpaine</li>
                            <li>säärihaavat, muut jalkojen verenkierto ongelmat</li>
                            <li>arvet</li>
                            <li>krooninen ripuli, mahakipu, pingotus ja turvotus</li>
                            <li>krooninen yskä</li>
                            <li>krooniset kivut, nivelkivut</li>
                            <li>lihasten voiman lisäys ja vahvistaminen</li>
                            <li>iho-ongelmat, kutina</li>
                            <li>erilaiset tuumorit, turpamat ja kertymät</li>
                            <li>puutuminen ja tunnottomuus</li>
                            <li>herpes zoster=vyöruusu, erysipelas=ruusu, mastiitti</li>
                        </ul>
                    </p>
                </div>
            </div>
            <div class="treatment-wrapper">
                <div class="description">
                    <h2>Kuivakuppaus</h2>
                    <p>
                        Kuppauksessa käytetään lasista, muovista tai silikonista valmistettuja kuppeja.
                        Kuppeja käytetään yleensä öljyn kanssa, jolloin voidaan puhua myös liukukuppauksesta.
                        Kuppiin muodostetaan alipaine, jonka jälkeen kuppia liu’utetaan lihaksen ja pehmytkudoksen päällä.
                        Kuppi voidaan myös asettaa yhteen kohtaan ja pitää paikallaan.
                    </p>
                    <p>
                        Kuivakuppaus on erityisen hyvä lihasvaivojen hoidossa.
                        Esimerkiksi niska-hartiaseudun pidempiaikaisetkin vaivat vastaavat hoitoon yleensä nopeasti.
                        Vaste tulee nopeasti ja kestää yleensä pitkään.
                        Alipaine rentouttaa lihaksia, poistaa kuona-aineita ja lisää alueen aineenvaihduntaa.
                    </p>
                    <p>
                        Huomioitavaa on, että hoidosta jää iholle jälkiä.
                        Osa kuppausjäljistä häviää iholta samana päivänä, mutta tummimmat jäljet saattavat kestää iholla reilun viikon.
                        Jäljet ovat vaarattomia ja niiden muodostuminen vähentyy hoitokertojen myötä.
                        Terveeseen kudokseen ei jää jälkiä hoidosta. Kuivakuppauksessa ei vuodateta verta.
                    </p>
                    <p>
                        Esimerkkjä hoidettavasta alueesta ja siihen varattavasta ajasta
                    </p>
                    <p>
                        Kuivakuppaus 30 min:
                        <br />
                        Niska-hartiaseutu tai selkä
                    </p>
                    <p>
                        Kuivakuppaus 45 min:
                        <br />
                        Niska-hartiaseutu, olkapäät ja selkä
                    </p>
                    <p>
                        Kuivakuppaus 90 min:
                        <br />
                        Alaraajat, lonkan seutu ja alaselkä
                        <br />
                        Niska-hartiaseutu, selkä ja kädet
                    </p>
                </div>
                <div class="image">
                    <img src="@/assets/cupping2.jpg" alt="Acupuncture treatment image">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TreatmentsPage'
    };
</script>

<style scoped>
    .treatment-wrapper {
        display: grid;
        grid-template-columns: auto auto;
        margin-bottom: 20px;
        align-items: center;
    }

        .treatment-wrapper img {
            width: 70%;
            height: auto;
            border-radius: 10px;
            margin: 20px 0px 0px 30px;
        }

    .description {
        padding: 30px;

    }

    .inline-list {
        display: inline-block;
        margin: 0;
        padding: 0;
        list-style-type: "-";
    }

        .inline-list li {
            display: list-item;
            list-style-position: inside;
        }

    @media (max-width: 768px) {
        .treatment-wrapper {
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;
        }
    }
</style>
